import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogProps, DialogTitle } from "@mui/material";

interface Props extends DialogProps {
  title: string;
  message: string;
  cancelText?: string;
  confirmText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmModal: React.FC<Props> = ({
  title,
  message,
  cancelText = "Cancelar",
  confirmText = "Confirmar",
  onConfirm,
  onCancel,
  ...dialogProps
}) => {
  return <Dialog {...dialogProps}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
    <DialogContent>
      <DialogContentText>{
        message.split('\n').map((line, index) => (
          <span key={index}>
            {line}
            <br />
          </span>
        ))
      }</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button variant="contained" color='error' onClick={onCancel}>
        {cancelText}
      </Button>
      <Button variant="contained" color='success' onClick={onConfirm} autoFocus>
        {confirmText}
      </Button>
    </DialogActions>
  </Dialog>;
};